import * as React from 'react';

import useIsInIframe from '@hooks/use-is-in-iframe';

import { ModalContainer } from '@components/modals/modal-container';

import { config } from '@/config.ts';

import { Footer } from './components/footer';
import { Header } from './components/header';
import { useFakeHeaderLogo } from './hooks/use-fake-header-logo';
import * as Styled from './layout.styled';

type OwnProps = {
	hasNavigation?: boolean;
	isFullScreen?: boolean;
	children: React.ReactNode;
};

const Layout: React.FC<OwnProps> = ({ hasNavigation = true, isFullScreen = false, children }) => {
	const isIframe = useIsInIframe();
	const brandLogo = useFakeHeaderLogo(config.BRAND);

	return (
		<Styled.Wrapper $isIframe={isIframe}>
			{!isIframe && (
				<Styled.FakeHeader>
					<Styled.FakeHeaderBody>{brandLogo}</Styled.FakeHeaderBody>
				</Styled.FakeHeader>
			)}

			{hasNavigation ? (
				<>
					<Header />
				</>
			) : null}

			<Styled.Container $isFullScreen={isFullScreen}>{children}</Styled.Container>
			<Footer />

			<ModalContainer />
		</Styled.Wrapper>
	);
};

export default Layout;
